import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsDashCircleFill } from 'react-icons/bs';
import { t } from "i18next";
import { startRegisterSearchInfo } from "../../app/actions/searchInfoActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { setPreviousSearchParams } from "../../app/actions/searchHistoryActions";
import { dispatchModulePaginatedSearch } from "../../app/helpers/moduleSearch.helper";

const FILTER_ALL = "all"

const INDICATOR_DEEP = "deep_indicator";
const INDICATOR_PROTECTION = "protection_indicator";
const INDICATOR_APPLICABILITY = "applicability_indicator";
const INDICATOR_RELEVANCE = "relevance_indicator";
const INDICATOR_MITIGATION = "mitigation_indicator";
const INDICATOR_ADAPTATION = "adaptation_indicator";
const INDICATOR_PERFORMANCE = "performance_indicator";

const FILTER_SERIES = "catalogserie_id";
const FILTER_SOPHISTICATIONS = "catalogsophistication_id"
const FILTER_MAGNITUDES = "catalogmagnitude_id"
const FILTER_SIZES = "catalogsize_id"
const FILTER_TYPOLOGIES = "catalogtypology_id"
const FILTER_PRICERANGES = "catalogpricerange_id"
const FILTER_PROBLEMS = "catalogproblem_ids"
const FILTER_PROBLEM = "catalogproblem_id"

const FILTER_MEASURE = "catalogmeasure_id";
const FILTER_STRATEGY = "catalogstrategy_id";
const FILTER_AMPLITUDE = "catalogamplitude_id";
const FILTER_MITIGATION = "catalogmitigation_id";

const FILTER_CIIUS = "catalogciiu_levels";
const FILTER_SECTIONS = "catalogsection_levels";
const FILTER_PHASES = "catalogphase_levels";
const FILTER_CONTINENTS = "catalogcontinents_id"
const FILTER_REGIONS = "catalogregions_id"
const FILTER_COUNTRIES = "catalogcountries_id"

const FILTER_INSTITUTIONS = "cataloginstitution_levels";

const FILTER_WORRIES = "worry_ids";
const FILTER_TOPICS = "topics_ids";
const FILTER_THEMES = "themes_ids";

const EndUserRemoveFilterOptionsL3 = ({
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  itemsPerPage,
  setItemsPerPage,
  moduleSelected,
  setModuleSelected,
  catalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter,
  groupVisionSelected,
  concernSelected
}) => {

  debugLogPages(":: EndUserRemoveFilterOptionsL3");

  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  const handleDeleteAllFilters = () => {

    setCatalogsToFilter([]);
    setIndicatorsToFilter([]);

    /*******> SEARCH_INFO <*******/
    const searchInfo = {
      text_search: searchTextState,
      indicators: [],
      filters: [],
      catalogmodule_id: moduleSelected.id,
      user_id: user.user_id,
      deleted: false
    }

    dispatch(startRegisterSearchInfo(searchInfo));

    //JT PAGE agrego size
    dispatch(setPreviousSearchParams({
      searchText: searchTextState,
      page: 0,
      size: itemsPerPage,
      catalogsToFilter: [],
      indicatorsToFilter: [],
      catalogModule: moduleSelected || {},
      catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
      groupVision: groupVisionSelected || {},
      concern: concernSelected || {}
    }));

    // Preparas los parámetros
    const searchParams = {
      searchText: searchTextState,
      moduleKey: moduleSelected?.key,
      page: 0,
      itemsPerPage: itemsPerPage,
      catalogsToFilter: [],
      indicatorsToFilter: [],
      codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
    };

    // Ejecutas el helper genérico
    dispatchModulePaginatedSearch(dispatch, searchParams);

  };

  const handleOnClickCatalog = (event, catalogCode) => {

    const catalogsToFilterList = [...catalogsToFilter];

    const indexForDelete = catalogsToFilterList.findIndex((item) => item.hasOwnProperty(catalogCode));

    if (indexForDelete !== -1) {
      catalogsToFilterList.splice(indexForDelete, 1);
    }

    setCatalogsToFilter(catalogsToFilterList);

    /*******> SEARCH_INFO <*******/
    const searchInfo = {
      text_search: searchTextState,
      indicators: indicatorsToFilter,
      filters: catalogsToFilterList,
      catalogmodule_id: moduleSelected.id,
      user_id: user.user_id,
      deleted: false
    }

    dispatch(startRegisterSearchInfo(searchInfo));

    //JT PAGE
    dispatch(setPreviousSearchParams({
      searchText: searchTextState,
      page: 0,
      size: itemsPerPage,
      catalogsToFilter: catalogsToFilterList,
      indicatorsToFilter: indicatorsToFilter,
      catalogModule: moduleSelected || {},
      catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
      groupVision: groupVisionSelected || {},
      concern: concernSelected || {}
    }));

    // Preparas los parámetros
    const searchParams = {
      searchText: searchTextState,
      moduleKey: moduleSelected?.key,
      page: 0,
      itemsPerPage: itemsPerPage,
      catalogsToFilter: catalogsToFilterList,
      indicatorsToFilter: indicatorsToFilter,
      codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
    };

    // Ejecutas el helper genérico
    dispatchModulePaginatedSearch(dispatch, searchParams);

  };

  const handleOnClickIndicator = (event, indicatorCode) => {

    const indicatorsToFilterList = [...indicatorsToFilter];

    const indexForDelete = indicatorsToFilterList.findIndex((item) => item.columnIndicator === indicatorCode);

    if (indexForDelete !== -1) {
      indicatorsToFilterList.splice(indexForDelete, 1);
    }

    setIndicatorsToFilter(indicatorsToFilterList);

    /*******> SEARCH_INFO <*******/
    const searchInfo = {
      text_search: searchTextState,
      indicators: indicatorsToFilterList,
      filters: catalogsToFilter,
      catalogmodule_id: moduleSelected.id,
      user_id: user.user_id,
      deleted: false
    }

    dispatch(startRegisterSearchInfo(searchInfo));

    //JT PAGE agrego size
    dispatch(setPreviousSearchParams({
      searchText: searchTextState,
      page: 0,
      size: itemsPerPage,
      catalogsToFilter: catalogsToFilter,
      indicatorsToFilter: indicatorsToFilterList,
      catalogModule: moduleSelected || {},
      catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
      groupVision: groupVisionSelected || {}
    }));

    // Preparas los parámetros
    const searchParams = {
      searchText: searchTextState,
      moduleKey: moduleSelected?.key,
      page: 0,
      itemsPerPage: itemsPerPage,
      catalogsToFilter: catalogsToFilter,
      indicatorsToFilter: indicatorsToFilterList,
      codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null
    };

    // Ejecutas el helper genérico
    dispatchModulePaginatedSearch(dispatch, searchParams);

  };

  return (
    <div>

      {/*Titulo*/}

      {((catalogsToFilter && catalogsToFilter.length > 0) || (indicatorsToFilter && indicatorsToFilter.length > 0)) && (
        <div style={{ fontWeight: '600', paddingTop: '1em', borderBottom: 'green 0.2em solid', fontSize:'1.4rem' }}>
          <span>{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.search.delete_filters`)}</span>
        </div>
      )}

      <div>
        {/*Indicadores Seleccionados*/}
        {indicatorsToFilter &&
          indicatorsToFilter.length > 0 &&
          indicatorsToFilter.map((element, index) => {
            if (element.columnIndicator === INDICATOR_DEEP && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_DEEP}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_DEEP)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );

            } else if (element.columnIndicator === INDICATOR_PROTECTION && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_PROTECTION}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_PROTECTION)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              )
            } else if (element.columnIndicator === INDICATOR_APPLICABILITY && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_APPLICABILITY}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_APPLICABILITY)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              )
            } else if (element.columnIndicator === INDICATOR_RELEVANCE && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_RELEVANCE}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_RELEVANCE)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              )
            } else if (element.columnIndicator === INDICATOR_MITIGATION && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_MITIGATION}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_MITIGATION)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              )
            } else if (element.columnIndicator === INDICATOR_ADAPTATION && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_ADAPTATION}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_ADAPTATION)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              )
            } else if (element.columnIndicator === INDICATOR_PERFORMANCE && element.valueIndicatorMin > 0 && element.valueIndicatorMax > 0) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">
                    {t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.indicator.${INDICATOR_PERFORMANCE}`)}
                  </span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickIndicator(event, INDICATOR_PERFORMANCE)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              )
            }
          })}
      </div>

      {/* Catalogos Seleccionados*/}
      <div>
        {catalogsToFilter &&
          catalogsToFilter.length > 0 &&
          catalogsToFilter.map((element, index) => {
            if (element.hasOwnProperty(FILTER_SERIES)) {

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_SERIES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_SERIES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );

            } else if (element.hasOwnProperty(FILTER_SOPHISTICATIONS)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_SOPHISTICATIONS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_SOPHISTICATIONS)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_SIZES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_SIZES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_SIZES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_TYPOLOGIES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_TYPOLOGIES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_TYPOLOGIES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_MAGNITUDES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_MAGNITUDES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_MAGNITUDES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_PRICERANGES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_PRICERANGES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_PRICERANGES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty("catalogcontinents_id")) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_CONTINENTS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, "catalogcontinents_id")}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty("catalogregions_id")) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_REGIONS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, "catalogregions_id")}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty("catalogcountries_id")) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_COUNTRIES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, "catalogcountries_id")}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_PROBLEMS)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_PROBLEMS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_PROBLEMS)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_PROBLEM)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_PROBLEM}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_PROBLEM)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_MEASURE)) {

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_MEASURE}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_MEASURE)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );

            } else if (element.hasOwnProperty(FILTER_STRATEGY)) {

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_STRATEGY}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_STRATEGY)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );

            } else if (element.hasOwnProperty(FILTER_AMPLITUDE)) {

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_AMPLITUDE}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_AMPLITUDE)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );

            } else if (element.hasOwnProperty(FILTER_MITIGATION)) {

              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_MITIGATION}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_MITIGATION)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );

            } else if (element.hasOwnProperty(FILTER_CIIUS)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_CIIUS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_CIIUS)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_SECTIONS)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_SECTIONS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_SECTIONS)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_PHASES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_PHASES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_PHASES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_INSTITUTIONS)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_INSTITUTIONS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_INSTITUTIONS)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_WORRIES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_WORRIES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_WORRIES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_TOPICS)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_TOPICS}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_TOPICS)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            } else if (element.hasOwnProperty(FILTER_THEMES)) {
              return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_THEMES}`)}</span>
                  <button className="iconButtonFilter"
                    key={index}
                    onClick={(event) => handleOnClickCatalog(event, FILTER_THEMES)}>
                    <BsDashCircleFill style={{ marginRight: '5px' }} />
                  </button>
                </div>
              );
            }
          })}
      </div>
      {/*Todos*/}
      <div>
        {((catalogsToFilter && catalogsToFilter.length > 0) || (indicatorsToFilter && indicatorsToFilter.length > 0)) && (

          <div style={{ display: 'flex', alignItems: 'center', borderTop: 'blue solid 0.1em' }}>
            <span className="tit-view-filter viewContentTitFilter">{t(`${moduleSelected && moduleSelected.key && moduleSelected.key}.filter.${FILTER_ALL}`)}</span>
            <button className="iconButtonFilter"
              onClick={handleDeleteAllFilters}>
              <BsDashCircleFill style={{ marginRight: '5px' }} />
            </button>
          </div>

        )}
      </div>
    </div>
  );
};

export default EndUserRemoveFilterOptionsL3;
